import { Component, Host, Prop, h } from '@stencil/core';

export type IcoButtonStyle = 'primary' | 'secondary' | 'tertiary' | 'tertiary-secondary' | 'next-navigation' | 'back-navigation' | 'final-action';
export type IcoButtonSize = 'xsmall' | 'small' | 'medium' | 'xmedium' | 'large' | 'xlarge';

@Component({
  tag: 'ico-button',
  styleUrl: 'ico-button.css',
})
export class IcoButton {
  @Prop() buttonSize: IcoButtonSize = 'medium';
  @Prop() buttonStyle: IcoButtonStyle = 'primary';
  @Prop() disabled = false;
  @Prop() htmlType: HTMLButtonElement['type'] = 'button';
  @Prop() label = 'button';
  @Prop() narrow = false;
  @Prop() target: HTMLAnchorElement['target'] = '_self';
  @Prop() htmlTitle = '';
  @Prop() url = '';
  @Prop() whenClicked: () => void = () => {};

  render() {
    const classList = {
      'ico-button': true,
      'ico-button--disabled': this.disabled,

      // Styles
      'ico-button--primary': this.buttonStyle === 'primary',
      'ico-button--secondary': this.buttonStyle === 'secondary',
      'ico-button--tertiary': this.buttonStyle === 'tertiary',
      'ico-button--tertiary-secondary': this.buttonStyle === 'tertiary-secondary',
      'ico-button--next-navigation': this.buttonStyle === 'next-navigation',
      'ico-button--back-navigation': this.buttonStyle === 'back-navigation',
      'ico-button--final-action': this.buttonStyle === 'final-action',

      // Sizes
      'ico-button--xlarge': this.buttonSize === 'xlarge',
      'ico-button--large': this.buttonSize === 'large',
      'ico-button--xmedium': this.buttonSize === 'xmedium',
      'ico-button--medium': this.buttonSize === 'medium',
      'ico-button--small': this.buttonSize === 'small',
      'ico-button--xsmall': this.buttonSize === 'xsmall',

      // Horizontal padding
      // Note: applying a fixed width to the button will override horizontal padding
      'ico-button--narrow': this.narrow,
    };

    return (
      <Host>
        {this.url ? (
          <a href={this.url} onClick={() => this.whenClicked()} target={this.target} class={classList} title={this.htmlTitle}>
            {this.label}
          </a>
        ) : (
          <button type={this.htmlType} onClick={() => this.whenClicked()} disabled={this.disabled} class={classList} title={this.htmlTitle}>
            {this.label}
          </button>
        )}
      </Host>
    );
  }
}
